import axios from 'axios'
import authService from '../auth/oidc'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/FinanceiroAPI',
  withCredentials: false
})

http.interceptors.request.use(async config => {
  const accessToken = await authService.getAccessToken()
  if (accessToken) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
})

http.interceptors.response.use(
  response => response,
  async error => {
    if (error?.response?.status === 401 && !error?.config?.skipAuthRedirect) {
      await authService.clearAuthState()
      const returnPath = `${window.location.pathname}${window.location.search}`
      await authService.signInRedirect(returnPath)
    }
    return Promise.reject(error)
  }
)

export default http
